export default "__VITE_ASSET__DyZGVlgg__"